{
  "commonHeader": {
    "toggleSidebar": "Mostrar u ocultar la barra lateral",
    "cartLoading": "Cargando el carrito",
    "cart": "Carrito",
    "aicForAdmin": {
      "ariaLabel": "IA para administradores"
    },
    "usersResults": "Usuarios, {0} resultados",
    "settingsResults": "Ajustes, {0} resultados",
    "navigationResults": "Navegación, {0} resultados",
    "learnMoreAbout": "Más información sobre {0}",
    "close": "Cerrar",
    "products": "Productos",
    "moreActions": "Más acciones",
    "search": "Buscar",
    "searchPlaceholderAll": "Buscar usuarios, ajustes de la cuenta o navegación",
    "searchPlaceholderUsers": "Buscar usuarios o navegación",
    "searchPlaceholderSettings": "Buscar ajustes de la cuenta o navegación",
    "searchPlaceholderNav": "Buscar navegación"
  },
  "footerCopyright": {
    "language": "Idioma {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "Menú de administrador"
    }
  },
  "shared": {
    "close": "Cerrar",
    "sideMenu": {
      "personalAria": "Menú personal",
      "adminAria": "Menú de administrador",
      "mainNav": "Navegación principal",
      "submenu": "Submenú",
      "pinnedSection": "{0} anclado",
      "sideMenuAria": "Menú lateral",
      "pinItem": "Anclar {0}",
      "unpinItem": "Desanclar {0}",
      "reorderGrabbed": "Reordenar {0}, agarrado. Use las flechas arriba y abajo para mover, espacio o Intro para soltar, Escape para cancelar.",
      "reorderIdle": "Reordenar {0}. Pulse espacio o Intro para agarrar.",
      "hintHandlePin": "Pulse Tab para acceder al controlador de arrastre y al botón de anclar",
      "hintHandle": "Pulse Tab para acceder al controlador de arrastre",
      "hintPin": "Pulse Tab para acceder al botón de anclar",
      "upgradeToPro": "Actualizar a Pro"
    },
    "item": "Elemento"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "Probar la nueva experiencia"
    }
  },
  "aicGuide": {
    "common": {
      "close": "Cerrar"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "Las divisiones ya están disponibles"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Administrar cuentas externas"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "La libreta de direcciones pasará a ser el directorio de clientes"
    }
  },
  "feedback": {
    "itemLableForProductArea": "Área de producto",
    "itemLableForFeedback": "Comentarios"
  }
}
